<template>
  <div id="mainCategoryPage">
    <section class="category_top_banner cover"  v-lazy:background-image=" mainCategory.thumb ?  mainCategory.thumb : ''" >
      <div class="container">
        <h1 class="title">{{ mainCategory.name }}</h1>
        <div class="text">{{ mainCategory.description }}</div>
      </div>
      <div class="bn_corner"></div>
    </section>
    <section class="inner_page">
      <div class="container">
        <Breadcrumbs :top="mainCategory"></Breadcrumbs>
        <div class="mobile_only">
          <div class="text">{{ mainCategory.description }}</div>
          <div class="m_categiries">
            <div class="m_categiry_item cover" v-for="(category) in filteredCatList(
                this.$store.state.categories
              )" :key="category.id" v-bind:style="[
                category.thumb
                  ? { backgroundImage: 'url(' + category.thumb + ')' }
                  : {}
              ]">
              <a-div class="absolute" :href="category.link.replace(home_url,'')">
                <span class="table100">
                  <span class="table_cell">{{ category.name }}</span>
                </span>
              </a-div>
            </div>
          </div>
        </div>
        <div class="no_mobile" v-if="$mq !== 'mobile'">
          <CategoryItem v-bind:category="category" v-bind:index="indexCat" v-for="(category, indexCat) in filteredCatList(this.$store.state.categories)" :key="category.id" :name="category.name"></CategoryItem>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import store from "../store";
  import CategoryItem from "../components/CategoryItem";
  import Breadcrumbs from "../components/Breadcrumbs";
  import { mapGetters } from "vuex";
  export default {
    store,
    metaInfo(){
      return{
        title: this.mainCategory.name,
        meta: [{
          vmid: 'description',
          name: 'description',
          content: this.mainCategory.description
        }]
    }
  },
    data() {
      return {
        home_url: wpData.home_url
      };
    },
    methods: {
      filteredCatList(items) {
        items = items.filter(category => {
          return category.parent == this.mainCategory.id;
        });
        return items;
      }
    },
    watch: {
      $route(to, form) {
        // this.$ajax({
        //   method: "POST",
        //   url: homeUrl + "ajax.php",
        //   params: {
        //     slug: this.mainCategory.slug
        //   }
        // }).then(res => {
        //   //this.$store.commit("setProducts", res.data);
        //   this.$store.state.products = res.data;
        // });
      }
    },
    beforeMount() {
      // this.$ajax({
      //   method: "POST",
      //   url: homeUrl + "ajax.php",
      //   params: {
      //     slug: this.mainCategory.slug
      //   }
      // }).then(res => {
      //   //this.$store.commit("setProducts", res.data);
      //   this.$store.state.products = res.data;
      // });
    },
    computed: {
      ...mapGetters(["categoriesBySlug", "productsByCat"]),
      mainCategory: function() {
        let slug = encodeURI(this.$route.params.cat).toLowerCase();

        var category = this.categoriesBySlug[slug];
        if (category) {
          return category;
        }
        return false;
      }
    },
    components: {
      CategoryItem,
      Breadcrumbs
    }
  };
</script>
